import React from 'react';
import { Link } from 'react-router-dom';
import { LifeBuoy } from 'lucide-react';

/** "3 days ago", "yesterday", "just now" — close enough is what this line is for. */
const ago = (iso) => {
  const then = new Date(iso);
  const mins = Math.round((Date.now() - then.getTime()) / 60000);
  if (mins < 2) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs === 1 ? '' : 's'} ago`;
  const days = Math.round(hrs / 24);
  if (days === 1) return 'yesterday';
  if (days < 31) return `${days} days ago`;
  return then.toLocaleDateString();
};

/**
 * One line on a member's card: when you last helped them, why, and whether anything changed.
 *
 * It only ever shows a visit the member actually allowed — a refused ask is not help, and
 * putting it here would turn a support record into a record of being watched.
 */
export const SupportHistoryLine = ({ entry, memberId }) => {
  if (!entry) return null;

  return (
    <p
      className="text-xs text-gray-500 mt-1 flex items-start gap-1.5"
      data-testid={`support-history-${memberId}`}
    >
      <LifeBuoy className="w-3 h-3 mt-0.5 flex-shrink-0" />
      <span>
        {entry.still_open ? 'Helping now' : `Helped ${ago(entry.at)}`}
        {entry.reason && <> — {entry.reason}</>}
        {' · '}
        <Link
          to={`/dashboard/admin?tab=account-access&member=${memberId}`}
          className="underline decoration-dotted hover:text-gray-300 transition-colors"
          data-testid={`support-history-link-${memberId}`}
        >
          {entry.changes > 0
            ? `${entry.changes} change${entry.changes === 1 ? '' : 's'}`
            : 'looked only'}
        </Link>
      </span>
    </p>
  );
};

export default SupportHistoryLine;
